export enum SessionStatus {
  LOADING = 'loading',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
}

/** A transport dialog the customer can open from the icons list. */
export interface TransportAction {
  title: string;
  items: string[];
}

export interface FinalDeliveryData {
  customerName: string;
  customerRemarks: string;
}

export interface PackingMaterialLineItem {
  item: string;
  unitPrice: string;
  amountUsed: number;
  total: string;
}

export interface PackingMaterialsItemization {
  title: string;
  sectionTitle: string;
  items: PackingMaterialLineItem[];
  totalQuantity: number;
  totalMaterialPrice: string;
}
